var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45693 1.78317V11.061L6.22694 9.29088C6.2725 9.24532 6.34636 9.24532 6.39192 9.29088L7.05183 9.95084C7.09739 9.9964 7.09739 10.0703 7.05183 10.1158L4.57715 12.5907L3.91724 13.2507C3.87168 13.2962 3.79782 13.2962 3.75226 13.2507L3.09234 12.5907L0.617664 10.1158C0.572107 10.0703 0.572107 9.9964 0.617664 9.95084L1.27758 9.29088C1.32314 9.24532 1.397 9.24532 1.44256 9.29088L3.21258 11.061V1.78317C3.21258 1.71874 3.26481 1.6665 3.32924 1.6665H4.34027C4.4047 1.6665 4.45693 1.71874 4.45693 1.78317ZM10.0131 1.749C10.0586 1.70344 10.1325 1.70344 10.1781 1.749L10.838 2.40897L13.3127 4.88384C13.3582 4.9294 13.3582 5.00327 13.3127 5.04883L12.6527 5.7088C12.6072 5.75436 12.5333 5.75436 12.4878 5.7088L10.7178 3.93865V13.2165C10.7178 13.2809 10.6655 13.3332 10.6011 13.3332H9.59007C9.52564 13.3332 9.47341 13.2809 9.47341 13.2165V3.93863L7.70338 5.7088C7.65783 5.75436 7.58396 5.75436 7.5384 5.7088L6.87849 5.04883C6.83293 5.00327 6.83293 4.9294 6.87849 4.88384L9.35295 2.40919L10.0131 1.749Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.9e5921a773fbda358ea7d9c2d3e40409.svg";
export { ForwardRef as ReactComponent };